module.exports = __webpack_public_path__ + "img/gsgc2901_2.ca63242a.svg";